import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { Flex } from "../../../../../components/Flex";
import { Info } from "../../../../../components/Info";
import { Modal } from "../../../../../components/modal/Modal";
import { TaskPriority } from "../../../../../model/task/types/TaskPriority.enum";
import { integrationSliceSelectors } from "../../../../../redux/integration/integration.selector";
import { integrationActions } from "../../../../../redux/integration/integration.slice";
import { useAppDispatch, useAppSelector } from "../../../../../redux/store";
import { userSliceSelectors } from "../../../../../redux/user/user.selector";
import { AtiraToast } from "../../../../../utils/AtiraToast";
import { WACommentForm } from "./WACommentForm";

type Props = {
  open: boolean;
  onClose: () => void;
  conversationId: string;
};

export const WACommentModal: React.FC<Props> = ({
  open,
  onClose,
  conversationId,
}) => {
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const userId = useAppSelector(userSliceSelectors.selectLoggedInUserId)!;
  const integration = useAppSelector(
    integrationSliceSelectors.selectWhatsAppMetaIntegration,
  );

  const onSubmit = async (body: string, priority: TaskPriority) => {
    try {
      setLoading(true);

      await dispatch(
        integrationActions.createWhatsappMetaComment({
          userId,
          integrationId: integration!._id,
          conversationId,
          body,
          priority,
        }),
      ).unwrap();

      AtiraToast.success(t("integration.whatsapp.meta.comments.created"));
      onClose();

      return true;
    } catch (e) {
      console.log(e);
      AtiraToast.apiError(e);

      return false;
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t("integration.whatsapp.meta.comments.add")}
      destroyOnHidden
    >
      <Flex flexDirection="column" gap="m" width="100%">
        <Info info={t("integration.whatsapp.meta.comments.info")} />

        <WACommentForm
          submitTitle={t("common.add")}
          loading={loading}
          onSubmit={onSubmit}
          onCancel={onClose}
          autoFocus
        />
      </Flex>
    </Modal>
  );
};
